const rechargeModal = {
  'rechargeModal.title': 'Recharge',
  'rechargeModal.inputLabel': 'Amount',
  'rechargeModal.generateRecharge': 'Generate payment slip',
  'rechargeModal.validUntil': 'Due date',
  'rechargeModal.instructions':
    'Use the code number below to pay until the due date.',
  'rechargeModal.emptyState': "There's no amount for recharge.",
  'rechargeModal.copied': 'Copied!',
  'rechargeModal.copy': 'Copy',
  'rechargeModal.sendBySMS': 'Send SMS',
  'rechargeModal.sentBySMS': 'SMS sent!',
  'rechargeModal.sendByEmail': 'Send email',
  'rechargeModal.sentByEmail': 'Email sent!',
  'rechargeModal.errorState':
    "Something went wrong and we couldn't fetch recharge data.",
  'rechargeModal.confirm': 'Confirm',
  'rechargeModal.closedValue': 'Total',
};

export default rechargeModal;
